import { jsx } from 'slate-hyperscript';

import hasPluginOfType from './has_plugin_of_type';
import sanitize from './sanitize_html';

export default function deserializeHtml(html, editor) {
  const sanitizedHtml = sanitize(html);
  const parsedDocument = new DOMParser().parseFromString(sanitizedHtml, 'text/html');
  return deserializeHtmlElement(parsedDocument.body, {}, editor);
}

export function deserializeHtmlElement(el, markAttributes = {}, editor) {
  if (el.nodeType === Node.TEXT_NODE) {
    return jsx('text', markAttributes, el.textContent);
  } else if (el.nodeType !== Node.ELEMENT_NODE) {
    return null;
  }

  const nodeAttributes = { ...markAttributes };
  switch (el.nodeName) {
    case 'STRONG':
    case 'B':
      nodeAttributes.bold = true;
      break;
    case 'EM':
    case 'I':
      nodeAttributes.italic = true;
      break;
    case 'U':
      nodeAttributes.underline = true;
      break;
    default:
      break;
  }

  const children = Array.from(el.childNodes)
    .map(node => deserializeHtmlElement(node, nodeAttributes, editor))
    .flat();

  if (children.length === 0) {
    children.push(jsx('text', nodeAttributes, ''));
  }

  switch (el.nodeName) {
    case 'BODY':
      return jsx('fragment', {}, children);
    case 'LI':
    case 'P':
    case 'DIV':
      return jsx('element', { type: 'p' }, children);
    case 'PLACEHOLDER':
      return jsx('element', { type: 'placeholder' }, children);
    case 'VARIABLE': {
      const attributes = {
        'data-id': el.getAttribute('data-id'),
        'data-type': el.getAttribute('data-type'),
        'data-value': el.getAttribute('data-value'),
      };
      return jsx('element', { attributes, type: 'variable' }, children);
    }
    case 'A': {
      if (!hasPluginOfType(editor, 'a')) {
        return children;
      }
      return jsx('element', { url: el.getAttribute('href'), type: 'a' }, children);
    }
    case 'BR':
    default:
      return children;
  }
}
